import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-dark sc-body overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#urlEventDetailModal",
  id: "urlEventDetailModalBtn",
  class: "d-none"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#urlLocationModal",
  id: "urlLocationModalBtn",
  class: "d-none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#urlArtistModal",
  id: "urlArtistModalBtn",
  class: "d-none"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventDetailModal = _resolveComponent("EventDetailModal")!
  const _component_LocationModal = _resolveComponent("LocationModal")!
  const _component_ArtistModal = _resolveComponent("ArtistModal")!
  const _component_Home = _resolveComponent("Home")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_EventDetailModal, {
      id: "urlEventDetailModal",
      event: _ctx.currEvent
    }, null, 8, ["event"]),
    _createVNode(_component_LocationModal, {
      id: "urlLocationModal",
      location: _ctx.currLocation
    }, null, 8, ["location"]),
    _createVNode(_component_ArtistModal, {
      id: "urlArtistModal",
      artist: _ctx.currArtist
    }, null, 8, ["artist"]),
    _createVNode(_component_Home),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}